import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, ArrowUp } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const askAIPath = (q, category = 'general') =>
  `/chat?category=${category}&send=1&q=${encodeURIComponent(q)}`;

export const AskAIBar = ({ chips = [], dark = false }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const go = (text) => text.trim() && navigate(askAIPath(text.trim()));

  return (
    <div className="space-y-2" data-testid="ask-ai-bar">
      <form onSubmit={(e) => { e.preventDefault(); go(q); }}
        className={`flex items-center gap-2 rounded-2xl border px-3 py-2 ${dark ? 'border-white/20 bg-white/10 backdrop-blur' : 'border-border bg-card'}`}>
        <Sparkles className={`h-4 w-4 shrink-0 ${dark ? 'text-emerald-300' : 'text-primary'}`} />
        <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="ask-ai-input"
          placeholder={t('Ask the AI Coach about your portfolio — why, which, how…', 'Muulize Mshauri wa AI kuhusu portfolio yako — kwa nini, ipi, vipi…')}
          className={`flex-1 bg-transparent text-sm outline-none ${dark ? 'text-white placeholder:text-white/50' : 'placeholder:text-muted-foreground'}`} />
        <button type="submit" disabled={!q.trim()} data-testid="ask-ai-submit"
          className="flex h-8 w-8 items-center justify-center rounded-xl bg-emerald-500 text-white transition-opacity duration-200 disabled:opacity-40">
          <ArrowUp className="h-4 w-4" />
        </button>
      </form>
      {chips.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {chips.map((c, i) => (
            <button key={c} type="button" onClick={() => go(c)} data-testid={`ask-ai-chip-${i}`}
              className={`rounded-full border px-3 py-1 text-xs transition-colors duration-200 ${dark ? 'border-white/20 text-white/80 hover:bg-white/10' : 'border-border text-muted-foreground hover:border-primary/40 hover:text-foreground'}`}>
              {c}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
